/**
 * Tracking Service
 * Stores events in a localStorage ring buffer (max 500) for analytics export.
 */

const MAX_EVENTS = 500;
const STORAGE_KEY = 'fpt_events';

export const track = (eventName: string, payload: any = {}) => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    let events = raw ? JSON.parse(raw) : [];
    
    const newEvent = {
      event: eventName,
      payload,
      timestamp: new Date().toISOString(),
      url: window.location.href
    };

    events.push(newEvent);
    
    if (events.length > MAX_EVENTS) {
      events = events.slice(-MAX_EVENTS);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
  } catch (e) {
    console.warn('[Track] Tracking failed:', e);
  }
};

export const getStoredEvents = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const clearEvents = () => {
  localStorage.removeItem(STORAGE_KEY);
};
